import { createRouter, createWebHistory,createWebHashHistory, RouteRecordRaw } from 'vue-router'

import Login from '../views/login/login2.vue'
import Layout from '../layout/index.vue'


const userList = () => import("@/views/user/userList.vue")


const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    name: 'main',
    component: Layout,
    redirect:"/account/list",
    children: [
      //系统用户
      {
        path: '/user',
        name: 'user',
        component: userList
      },
      //银行账户
      {
        path: '/account',
        name: 'account',
        component: () => import("@/views/bank/account/index.vue"),
        children: [
          {
            path: 'list',
            name: 'subaccountlist',
            component:()=> import("@/views/bank/account/list.vue"),
           
          },
          {
            path: 'detail/:sqno/:name',
            name: 'subaccountdetail',
            component: () => import('@/views/bank/account/detail.vue')
          },
          {
            path: 'add',
            name: 'addSubAccount',
            component:()=> import('@/views/bank/account/addSubAccount.vue')
          },

        ]
      },
      //通知存款
      {
        path: '/tzck/list',
        name: 'tzck_list',
        component: ()=>import('@/views/bank/tzck/list.vue'),
        
      },
      {
        path: '/tzck/add',
        name: 'tzck_add',
        component: ()=>import('@/views/bank/tzck/add.vue'),
        
      },
      {
        path: '/tzck/hdcx',
        name: 'tzck_hdcx',
        component: ()=>import('@/views/bank/tzck/hdcx.vue'),
        
      },
      {
        path: '/tzck/cktq',
        name: 'tzck_cktq',
        component: ()=>import('@/views/bank/tzck/cktq.vue'),
        
      },

      //资金清分
      {
        path: '/zjqf/list',
        name: 'zjqf_list',
        component: ()=>import('@/views/bank/zjqf/list.vue'),
        
      },
      {
        path: '/zjqf/sgqf',
        name: 'zjqf_sgqf',
        component: ()=>import('@/views/bank/zjqf/sgqf.vue'),
        
      },

      // 资金统计
      {
        path: '/zjtj/record',
        name: 'zjtj_record',
        component: ()=>import('@/views/zjtj/record1.vue'),
        
      },
      {
        path: '/zjtj/list',
        name: 'zjtj_list',
        component: ()=>import('@/views/zjtj/list2.vue'),
        
      },

    ]
  },

]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // const store = useStore()
  // const userinfo = store.getters['user/getUserInfo']
  const whiteList = ['/login']
  const userInfoJson = localStorage.getItem('userInfo')
  if (userInfoJson !== null) {
    // 如果数据存在，解析 JSON 字符串
    interface UserInfo {
      // 属性定义
      id: number;
      username: string;
      token: string;
    }
    const userInfo: UserInfo | null = JSON.parse(userInfoJson);

    if (userInfo !== null) {
      // 数据已成功解析
      // console.log('user Info:', userInfo);

      next()
    } else {
      // JSON 解析失败
      console.error('Failed to parse user info JSON.');
    }
  } else {
    // localStorage 中没有名为 'userInfo' 的数据
    console.log('No user info found in localStorage.');
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
  }



})

export default router
